// @flow
import type { Action } from './store.type';
import type { ProductRankingType } from 'src/models/product-ranking';

export const GET_PRODUCT_RANKING_REQUEST = 'GET_PRODUCT_RANKING_REQUEST';
type GET_PRODUCT_RANKING_REQUEST_TYPE = 'GET_PRODUCT_RANKING_REQUEST';

export const GET_PRODUCT_RANKING_SUCCESS = 'GET_PRODUCT_RANKING_SUCCESS';
type GET_PRODUCT_RANKING_SUCCESS_TYPE = 'GET_PRODUCT_RANKING_SUCCESS';

export const GET_PRODUCT_RANKING_FAILURE = 'GET_PRODUCT_RANKING_FAILURE';
type GET_PRODUCT_RANKING_FAILURE_TYPE = 'GET_PRODUCT_RANKING_FAILURE';

export const UPDATE_PRODUCT_RANKING_REQUEST = 'UPDATE_PRODUCT_RANKING_REQUEST';
type UPDATE_PRODUCT_RANKING_REQUEST_TYPE = 'UPDATE_PRODUCT_RANKING_REQUEST';

export const UPDATE_PRODUCT_RANKING_SUCCESS = 'UPDATE_PRODUCT_RANKING_SUCCESS';
type UPDATE_PRODUCT_RANKING_SUCCESS_TYPE = 'UPDATE_PRODUCT_RANKING_SUCCESS';

export const UPDATE_PRODUCT_RANKING_FAILURE = 'UPDATE_PRODUCT_RANKING_FAILURE';
type UPDATE_PRODUCT_RANKING_FAILURE_TYPE = 'UPDATE_PRODUCT_RANKING_FAILURE';

type ProductRankingFailure = {
  error: any
};

type GetProductRankingRequestAction = Action<GET_PRODUCT_RANKING_REQUEST_TYPE, null>;

type GetProductRankingSuccessAction = Action<
  GET_PRODUCT_RANKING_SUCCESS_TYPE,
  { data: { data: ProductRankingType, total: number, totalRanked: number } }
>;

type GetProductRankingFailureAction = Action<
  GET_PRODUCT_RANKING_FAILURE_TYPE,
  ProductRankingFailure
>;

type UpdateProductRankingRequestAction = Action<UPDATE_PRODUCT_RANKING_REQUEST_TYPE, null>;

type UpdateProductRankingSuccessAction = Action<
  UPDATE_PRODUCT_RANKING_SUCCESS_TYPE,
  {
    products: ProductRankingType,
    totalRanked: number
  }
>;

type UpdateProductRankingFailureAction = Action<
  UPDATE_PRODUCT_RANKING_FAILURE_TYPE,
  ProductRankingFailure
>;

export type ProductRankingAction =
  | GetProductRankingRequestAction
  | GetProductRankingSuccessAction
  | GetProductRankingFailureAction
  | UpdateProductRankingRequestAction
  | UpdateProductRankingSuccessAction
  | UpdateProductRankingFailureAction;

export type ProductRankingState = {
  loading: boolean,
  saving: boolean,
  success: boolean,
  saveSuccess: boolean,
  error: any,
  productRanking: ProductRankingType,
  total: number,
  totalRanked: number
};
